import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter, Inject,
  Input, OnInit,
  Output,
} from "@angular/core";
import {countries} from "../../constants/commons";

require('./bringoz-country-code-select.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-country-code-select',
  templateUrl: './bringoz-country-code-select.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozCountryCodeSelectComponent implements OnInit {

  @Input() countryCode: any;
  @Input() isDisabled: boolean;

  @Output() onChange = new EventEmitter<any>();

  public countries: any;
  public siteCountryCode: any;

  constructor(@Inject('splitService') private splitService) {
  }

  ngOnInit() {
    this.countries = countries;
    this.siteCountryCode = this.splitService.getCountryCode();
  }

  customSearch(term: string, item: any) {
    if (!term) {
      return true;
    }
    term = term.toLowerCase();
    return item.name.toLowerCase().includes(term) || item.dial_code.includes(term);
  }

}
